import { motion } from "framer-motion";
import { Loader2, X } from "lucide-react";

export const inputCls = "w-full rounded-xl border border-inkline bg-parchment px-4 py-2.5 text-sm text-ink outline-none transition-colors placeholder:text-muted2/60 focus:border-spice";

export const EditorModal = ({ title, testid, onClose, onSave, busy, saveLabel, children }) => (
  <motion.div
    initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
    className="fixed inset-0 z-[70] flex items-end justify-center bg-ink/60 backdrop-blur-sm sm:items-center sm:p-6"
    onClick={onClose}
    data-testid={`${testid}-modal`}
  >
    <motion.form
      initial={{ y: 60, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 60, opacity: 0 }}
      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      onClick={(e) => e.stopPropagation()}
      onSubmit={onSave}
      className="max-h-[92vh] w-full max-w-2xl overflow-y-auto rounded-t-3xl bg-parchment p-7 sm:rounded-3xl sm:p-9"
      data-testid={testid}
    >
      <div className="flex items-center justify-between">
        <h3 className="font-display text-2xl font-semibold text-ink">{title}</h3>
        <button type="button" data-testid={`${testid}-cancel-btn`} onClick={onClose} className="flex h-9 w-9 items-center justify-center rounded-full bg-cream text-ink transition-colors hover:bg-spice hover:text-parchment" aria-label="Close editor">
          <X size={17} />
        </button>
      </div>
      <div className="mt-6 space-y-4">{children}</div>
      <button type="submit" data-testid={`${testid}-save-btn`} disabled={busy} className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-spice py-3.5 text-sm font-bold text-parchment transition-colors hover:bg-ink disabled:opacity-60">
        {busy && <Loader2 size={15} className="animate-spin" />}
        {saveLabel}
      </button>
    </motion.form>
  </motion.div>
);

export const ActivePill = ({ active, onClick, testid }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    className={`rounded-full px-3.5 py-1.5 text-xs font-bold transition-colors ${active ? "bg-halal/10 text-halal" : "bg-ink/10 text-ink"}`}
  >
    {active ? "Live" : "Hidden"}
  </button>
);
